var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author"},[_vm._v(" 负责人：晁凯 "),_c('br'),_vm._v("邮箱：chaokai@tom.com "),_c('br'),_c('br'),_c('el-button',{staticClass:"btn",on:{"click":_vm.back}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }